import { render, staticRenderFns } from "./Page-Not-Found-Plan.vue?vue&type=template&id=06eef5e0&"
import script from "./Page-Not-Found-Plan.vue?vue&type=script&lang=js&"
export * from "./Page-Not-Found-Plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports